import lodash from "lodash";
import {
  getPluginConfig,
  hasPlugin as hasPluginInPlugins,
  parseInstance
} from "./../wix-ricos-common";
import {
  AUDIO_TYPE,
  GIPHY_TYPE,
  IMAGE_TYPE,
  LINK_PREVIEW_TYPE,
  VERTICAL_EMBED_TYPE
} from "./../ricos-content";
import audioStrategy from "./audioStrategy/audioStrategy";
import giphyStrategy from "./giphyStrategy/giphyStrategy";
import imageEditorStrategy from "./imageEditorStrategy/imageEditorStrategy";
import linkPreviewStrategy from "./linkPreviewStrategy/linkPreviewStrategy";
import mediaManagerStrategy from "./mediaManagerStrategy/mediaManagerStrategy";
import uploadStrategy from "./uploadStrategy/uploadStrategy";
import { verticalEmbedEditorStrategy } from "./verticalEmbedEditorStrategy/verticalEmbedEditorStrategy";
import videoThumbnailStrategy from "./videoThumbnailStrategy";
const runEditorStrategies = (plugins, instance, getWixClientPromise, biSettings, visitorUploads, fileUploadSizeLimit) => {
  const hasPlugin = (pluginType) => hasPluginInPlugins(pluginType, plugins);
  const getConfig = (pluginType) => getPluginConfig(pluginType, plugins);
  const { metaSiteId, uid, appDefId, siteOwnerId } = parseInstance(instance);
  const { imageEditor, consumer = biSettings?.consumer } = getConfig(IMAGE_TYPE);
  return lodash.merge(
    uploadStrategy(
      metaSiteId,
      uid,
      siteOwnerId,
      instance,
      hasPlugin,
      getConfig,
      getWixClientPromise,
      visitorUploads,
      consumer,
      fileUploadSizeLimit
    ),
    mediaManagerStrategy(hasPlugin, appDefId),
    hasPlugin(LINK_PREVIEW_TYPE) && linkPreviewStrategy(instance),
    hasPlugin(AUDIO_TYPE) && audioStrategy(instance, hasPlugin),
    hasPlugin(VERTICAL_EMBED_TYPE) && verticalEmbedEditorStrategy(instance, hasPlugin),
    videoThumbnailStrategy(instance, hasPlugin),
    imageEditor && imageEditorStrategy(instance, metaSiteId, uid, consumer),
    hasPlugin(GIPHY_TYPE) && !getConfig(GIPHY_TYPE).giphySdkApiKey && giphyStrategy()
  );
};
export {
  runEditorStrategies
};
//# sourceMappingURL=runEditorStrategies.js.map
